import '../scss/main.scss';

document.addEventListener('DOMContentLoaded', () => {
	const dateFields = document.querySelectorAll('.report-form input[type="date"]');

	dateFields.forEach((field) => {
		field.addEventListener('click', () => {
			if (typeof field.showPicker === 'function') {
				field.showPicker();
			}
		});
	});
});

// Redirect after CF7 success.
// document.addEventListener('wpcf7mailsent', (event) => {
// 	const form = event.target;

// 	if (!form.querySelector('.report-form')) {
// 		return;
// 	}

// 	window.location.href = '/index.php/dziekujemy-za-przeslanie-formularza/';
// });